import actionTypes from 'SRC/modules/redux/actionTypes'

export const setSimilarProductsLoading = isLoading => ({
  type: actionTypes.SET_VEHICLE_PARTS_SIMILAR_PRODUCTS_LOADING,
  payload: isLoading
})
